export default "__VITE_ASSET__BsTxw1ts__"